import React from "react";

function Sign({className}) {
  return (
    <svg
      className={className}  
      viewBox="0 0 316 316"
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M85.889 171.485C83.8176 168.37 81.9777 167.064 80.7255 167.315C95.7915 191.825 96.7834 214.355 99.7844 216.233M22.7969 206.455C64.7278 155.852 139.753 101.72 147.985 108.413C156.217 115.107 65.8202 203.181 69.3471 207.646C72.874 212.11 156.899 146.649 173.179 156.982C189.458 167.315 59.4626 256.975 55.7412 249.678C45.3066 229.218 270.173 70.4242 272.908 75.6078M178.964 138.803C169.345 148.716 170.883 161.608 176.65 164.674C182.418 167.739 185.321 145.762 181.909 130.179C181.46 128.131 179.502 128.257 178.964 130.179C178.426 132.1 181.055 153.701 186.052 155.757C190.152 156.982 199.644 113.996 194.197 111.763C188.75 109.529 189.972 151.771 197.681 147.605C205.389 143.438 201.569 115.999 198.02 80.117C197.92 79.1066 196.009 79.4948 196.208 80.9565C199.081 102.087 202.795 122.597 211 134.651C219.206 146.705 216.334 115.484 214.313 111.763C212.292 108.041 211.701 111.763 211.701 111.763C212.051 125.803 214.313 131.599 218.287 132.658C222.262 133.717 224.673 96.9922 223.868 100.716C223.063 104.44 222.566 118.158 227.82 119.846C233.074 121.533 236.047 93.729 233.069 95.3928C230.381 96.8948 224.224 106.079 236.435 108.359C248.646 110.639 245.344 113.667 243.561 115.91C241.778 118.154 238.456 118.55 238.456 113.996C238.456 109.442 238.9 73.4866 240.198 67.6852C241.496 61.8837 237.8 60.3784 237.818 68.2628C237.836 76.1472 249.435 116.537 252.389 111.763C255.342 106.988 253.346 94.8518 253.346 94.8518C255.855 102.253 255.736 107.481 260.897 105.594C266.058 103.706 268.631 85.7336 267.917 83.7908C267.202 81.848 264.902 81.2393 263.662 84.8544C262.423 88.4694 261.754 94.9319 278.044 94.0663C294.333 93.2007 65.678 248.985 68.6553 252.302C71.6326 255.618 292.397 100.701 292.397 100.701"
        stroke="#CFEF00"
      >
        <animate
          attributeType="XML"
          attributeName="stroke-dasharray"
          repeatCount="1"
          dur="5.555555555555555s"
          values="0,0,0,2121.531005859375; 
          0,1060.7655029296875,1060.7655029296875,0; 
          2121.531005859375,0,0,0"
          keyTimes="0; 0.5; 1"
          fill="freeze"
        ></animate>
      </path>
    </svg>
  );
}

export default Sign;
